import i18n from '@shared/i18n/i18n';
import en from './en/entry.json';
import es from './es/entry.json';

// Registrar las traducciones al importar el módulo
if (!i18n.hasResourceBundle('es', 'merchandiseV3')) {
  i18n.addResourceBundle('es', 'merchandiseV3', es);
}

if (!i18n.hasResourceBundle('en', 'merchandiseV3')) {
  i18n.addResourceBundle('en', 'merchandiseV3', en);
}

export { es, en };

